import { defaultJwtExpiry, signJwtV2 } from "@core-services/utils"
import { Cross1Icon } from "@radix-ui/react-icons"
import { Dialog, DialogClose, DialogContent } from "@vindral/components"
import { useEffect, useState } from "react"
import { ChannelFindById } from "../templates/channel/ChannelEdit"
import { HlsVideoPlayer } from "../templates/channel/edit/playout/HlsPlayer"
import { hlsUrl } from "../utils/urls"

export interface HlsDialogProps {
  channel: ChannelFindById
  onCancel?: () => Promise<void> | void
  open: boolean
}

export function HlsDialog({ channel, onCancel, open }: HlsDialogProps) {
  const [url, setUrl] = useState<string>("")
  const authSecret = channel.organization.authSecret
  const { authRequired, channelId } = channel

  useEffect(() => {
    const authToken = authRequired
      ? signJwtV2({
          authSecret,
          channelId,
          scope: {
            playout: true,
          },
          expiresAt: defaultJwtExpiry(),
        })
      : undefined

    const url = hlsUrl({ channelId, authToken })
    setUrl(url)
  }, [authSecret, authRequired, channelId])

  return (
    <Dialog open={open}>
      <DialogContent size="medium" onInteractOutside={onCancel}>
        <form className="break-words">
          <div className="flex items-start justify-between gap-2 p-3">
            <span className="min-w-0 font-medium">HLS Preview</span>
            <DialogClose className="" onClick={onCancel}>
              <Cross1Icon></Cross1Icon>
            </DialogClose>
          </div>
          <div className="overflow-y-auto">
            <HlsVideoPlayer src={url} startOnLoad />
          </div>
          <div className="flex justify-end gap-3 border-t border-divider p-3"></div>
        </form>
      </DialogContent>
    </Dialog>
  )
}
